import { render } from "./CreateInfoDayService.vue?vue&type=template&id=0d80550b&scoped=true"
import script from "./CreateInfoDayService.vue?vue&type=script&lang=js"
export * from "./CreateInfoDayService.vue?vue&type=script&lang=js"

import "./CreateInfoDayService.vue?vue&type=style&index=0&id=0d80550b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d80550b"]])

export default __exports__